module.exports = __webpack_public_path__ + "img/expl-selfie-2.9d5b134b.svg";